import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { ReactComponent as CloseIcon } from '../assets/arv/close.svg'

export default function GalleryModal({ photos = [], onClose }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = "hidden";
    return () => { 
      document.body.style.overflow = '';
      document.documentElement.style.overflow = "";
    }
  }, [])

  const isMac = navigator.userAgent.includes('Mac');
  const containerStyle = {
    paddingRight: isMac ? '24px' : '7px',
  };

  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-start justify-center"
      style={{ background: 'rgba(0,0,0,0.55)', padding: '40px 60px' }}
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-2xl w-full overflow-y-auto scrollbar-gutter-stable"
        style={{ maxWidth: 1300, maxHeight: 'calc(100vh - 80px)', overscrollBehavior:'contain' }}
        onClick={e => e.stopPropagation()}
      >

        <div className="p-[24px] grid grid-cols-3 gap-[8px]" style={containerStyle}>
          {photos.map((photo, i) => (
            <div
              key={i}
              className="rounded-[8px] overflow-hidden bg-brand-grayGreen"
              style={{ aspectRatio: '3/2' }}
            >
              <img
                src={photo.href}
                alt={`Photo ${i + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.getElementById('portal')
  )
}
